/**
 * Predictive Search component
 * 
 * @module predictive-search
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'predictive-search';

 if(!customElements.get(customElements.component)) {
  class PredictiveSearch extends HTMLElement {

    /**
     * Predictive search component
     * 
     * @constructor
     */
    constructor() {
      super();
  
      this.inputs = this.querySelectorAll('input[type="search"]');

      this.predictiveSearchDisabled = (typeof this.dataset.predictiveSearchDisabled != 'undefined') ? true : false;

      if(this.predictiveSearchDisabled == true){
        return;
      }

      this.predictiveSearchResults = this.querySelectorAll('[data-predictive-search]');
      
      this.inputs.forEach(input => {
        input.addEventListener('input', window.theme.debounce.apply(event => {
          this.onChange(event);
        }, 300).bind(this));
      });

      this.inputs.forEach(input => {
        input.addEventListener('focus', this.onFocus.bind(this));
      });

      this.inputs.forEach(input => {
        input.addEventListener('blur', this.onFocusOut.bind(this));
      });
      
    }
  
    /**
     * on Change
     * 
     * @returns {undefined}
     */
    onChange(event) {
      const searchTerm = event.target.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    /**
     * Get search results
     * 
     * @param {string} searchTerm Search Term
     * @returns {undefined}
     */
    getSearchResults(searchTerm) {
      fetch(`${window.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,page&${encodeURIComponent('resources[limit]')}=5&section_id=predictive-search&${encodeURIComponent('resources[options][fields]')}=${window.theme.search_terms}&resources[limit_scope]=each`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.forEach(predictiveSearch => {
            predictiveSearch.innerHTML = resultsMarkup;
          })
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    /**
     * Open predictive search
     * 
     * @returns {undefined}
     */
    open() {
      this.querySelectorAll('[data-predictive-search-desktop]').forEach(predictiveSearch => {
        predictiveSearch.style.display = 'block';
      });
      this.setAttribute('open', true);  
    }
  
    /**
     * Close predictive search
     * 
     * @returns {undefined}
     */
    close() {
      this.querySelectorAll('[data-predictive-search-desktop]').forEach(predictiveSearch => {
        predictiveSearch.style.display = 'none';
      });
      this.removeAttribute('open');
    }

    /**
     * Get Query
     * 
     * @returns {string}
     */
    getQuery(value) {
      return value.trim();
    }

    /**
     * On Focus
     * 
     * @returns {undefined}
     */
    onFocus(event) {
      const searchTerm = this.getQuery(event.target.value);
  
      if (!searchTerm.length) return;
  
      if (this.getAttribute('open') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    } 
  
    /**
     * On Focus out
     * 
     * @returns {undefined}
     */
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
          this.closest('search-bar')?.close();
        }          
      });
    }
    
  }
  
  customElements.define(customElements.component, PredictiveSearch);
}
